import React, { useEffect } from 'react'
import ReactGA from "react-ga4";
import { useAuthService } from '../../Context/AuthContext';
import packageJson from "../../../package.json";

const appVersion = packageJson.version;

const InitializeAnalytics = () => {
    const TRACKING_ID = "G-BX8Z7GXZFV";
    useEffect(() => {
        ReactGA.initialize(TRACKING_ID);
        ReactGA.event({
            category: "App",
            action: "Version",
            label: appVersion,
        });
        if (window.electron) {
            ReactGA.event({
                category: "App",
                action: "Architecture",
                label: window.electron.platform.arch,
            });
            ReactGA.gtag("set", "user_properties", { os_arch: window.electron.platform.arch });
        }
    }, [])
}

export default InitializeAnalytics